module.exports = __webpack_public_path__ + "static/media/cable-park-opti.f6b4e4ec.mp4";